(function () {
  'use strict';
  if (window.__LCFiveTools) return;
  window.__LCFiveTools = true;
  var lang = (document.documentElement.lang || 'nl').toLowerCase().split('-')[0];
  var de = lang === 'de';
  var RECENT_KEY = 'laadcentrum:recent:v1';
  var allowedHandle = /^[a-z0-9][a-z0-9-]{0,150}$/;

  function sameShopPath(value, fallback) {
    try {
      var u = new URL(value || fallback, window.location.origin);
      if (u.origin !== window.location.origin || !u.pathname.startsWith('/')) return fallback;
      return u.pathname + u.search;
    } catch (_) {
      return fallback;
    }
  }
  function imageUrl(value) {
    try {
      var u = new URL(value || '', window.location.href);
      return u.protocol === 'https:' && (u.hostname === 'cdn.shopify.com' || u.hostname === window.location.hostname) ? u.href : '';
    } catch (_) { return ''; }
  }
  function getRecent() {
    try {
      var raw = JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]');
      if (!Array.isArray(raw)) return [];
      var used = new Set();
      return raw.filter(function (p) {
        if (!p || !allowedHandle.test(p.handle || '') || used.has(p.handle)) return false;
        used.add(p.handle);
        return true;
      }).slice(0, 8).map(function (p) {
        return {
          handle: p.handle,
          title: String(p.title || p.handle).slice(0, 190),
          url: sameShopPath(p.url, '/products/' + p.handle),
          image: imageUrl(p.image)
        };
      });
    } catch (_) { return []; }
  }
  function recordRecentView() {
    var node = document.querySelector('[data-lc-recent-product]');
    if (!node) return;
    var handle = node.getAttribute('data-lc-handle') || '';
    if (!allowedHandle.test(handle)) return;
    var item = {
      handle: handle,
      title: (node.getAttribute('data-lc-title') || handle).slice(0, 190),
      url: sameShopPath(node.getAttribute('data-lc-url'), '/products/' + handle),
      image: imageUrl(node.getAttribute('data-lc-image'))
    };
    var items = getRecent().filter(function (p) { return p.handle !== handle; });
    items.unshift(item);
    try { window.localStorage.setItem(RECENT_KEY, JSON.stringify(items.slice(0, 8))); } catch (_) {}
  }
  function buildRecent() {
    var section = document.querySelector('[data-lc-recent-section]');
    if (!section) return;
    var grid = section.querySelector('[data-lc-recent-grid]');
    if (!grid) return;
    var recent = getRecent().slice(0, 4);
    grid.replaceChildren();
    if (!recent.length) { section.hidden = true; return; }
    recent.forEach(function (p) {
      var item = document.createElement('a');
      item.className = 'lce-recent__item';
      item.href = p.url;
      var media = document.createElement('div');
      media.className = 'lce-recent__media';
      if (p.image) {
        var image = document.createElement('img');
        image.alt = '';
        image.loading = 'lazy';
        image.src = p.image;
        media.appendChild(image);
      }
      var content = document.createElement('div');
      content.className = 'lce-recent__content';
      var title = document.createElement('strong');
      title.textContent = p.title;
      var cta = document.createElement('span');
      cta.textContent = de ? 'Zum Produkt →' : 'Bekijk product →';
      content.append(title, cta);
      item.append(media, content);
      grid.appendChild(item);
    });
    section.hidden = false;
  }
  function modelFinder() {
    document.querySelectorAll('[data-lc-model-form]').forEach(function (form) {
      if (form.dataset.lcBound === 'true') return;
      form.dataset.lcBound = 'true';
      var brand = form.querySelector('[data-lc-model-brand]');
      var model = form.querySelector('[data-lc-model-variant]');
      var category = form.querySelector('[data-lc-model-category]');
      var query = form.querySelector('[data-lc-model-q]');
      if (!brand || !model || !category || !query) return;

      function reconcileBrand() {
        var visible = [];
        Array.prototype.forEach.call(model.options, function (option) {
          var match = option.getAttribute('data-lc-brand') === brand.value;
          option.hidden = !match;
          option.disabled = !match;
          if (match) visible.push(option);
        });
        if (!visible.some(function (option) { return option.selected; }) && visible.length) {
          model.value = visible[0].value;
        }
        updateQuery();
      }
      function updateQuery() {
        var suffix = { cases:'hoesje', glass:'screenprotector', chargers:'oplader' }[category.value] || 'accessoires';
        if (de) suffix = { cases:'Hülle', glass:'Displayschutz', chargers:'Ladegerät' }[category.value] || 'Zubehör';
        query.value = (model.value || 'iPhone 17') + ' ' + suffix;
      }
      brand.addEventListener('change', reconcileBrand);
      model.addEventListener('change', updateQuery);
      category.addEventListener('change', updateQuery);
      form.addEventListener('submit', function (event) {
        updateQuery();
        var selected = model.options[model.selectedIndex];
        if (!selected) return;
        var direct = selected.getAttribute('data-lc-' + category.value);
        if (!direct) return;
        var fallback = null;
        try {
          var dest = new URL(direct, window.location.origin);
          if (dest.origin === window.location.origin && dest.pathname.indexOf('/collections/') !== -1) {
            event.preventDefault();
            window.location.assign(dest.pathname + dest.search);
          }
        } catch (_) { /* Search form stays functional as fallback. */ }
      });
      reconcileBrand();
    });
  }
  function comparer() {
    document.querySelectorAll('[data-lc-compare]').forEach(function (section) {
      if (section.dataset.lcBound === 'true') return;
      section.dataset.lcBound = 'true';
      var checks = Array.prototype.slice.call(section.querySelectorAll('[data-lc-compare-check]'));
      var cells = Array.prototype.slice.call(section.querySelectorAll('[data-lc-compare-col]'));
      var count = section.querySelector('[data-lc-compare-count]');
      if (!checks.length || !cells.length) return;
      function update(event) {
        var enabled = checks.filter(function (input) { return input.checked; }).map(function (input) { return input.getAttribute('data-lc-compare-check'); });
        if (!enabled.length && event && event.target) {
          event.target.checked = true;
          enabled = [event.target.getAttribute('data-lc-compare-check')];
        }
        cells.forEach(function (cell) { cell.hidden = enabled.indexOf(cell.getAttribute('data-lc-compare-col')) === -1; });
        if (count) count.textContent = de ? enabled.length + ' Geräte ausgewählt. ' : enabled.length + ' opladers geselecteerd. ';
      }
      checks.forEach(function (input) { input.addEventListener('change', update); });
      update();
    });
  }
  function init() {
    recordRecentView();
    modelFinder();
    comparer();
    buildRecent();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
})();
